<template>
  <div class="exchange-container">
    <top-nav :shrinked="true"/>
    <img class="banner" src="@/assets/exchange/banner.jpg">
    <div class="exchange-container-content">
      <div class="site-text__content honor-base">
        <h3 class="text-blue site-text__content_h3">嘉宏置换中心</h3>
        <div class="site-text__content_desc site-text__content_desc_align_left">
          <p>作为专业的资产处置与房产置换服务机构,致力于为您提供全方位、一站式的优质服务。</p>
          <p>职能涵盖以旧换新评估、定价、磋商、抵押、过户,以及房源代售(包括新房和旧房)和滞重资产处置。凭借专业的团队和丰富的经验，精准评估资产价值,为您提供合理的定价和磋商方案，确保每一次交易的公平与透明。</p>        </div>
      </div>
      <div class="grid-content">
        <h3 class="text-blue site-text__content_h3">嘉宏置换中心</h3>
        <div class="grid-bg">
          <div v-for="(item,index) in cateList"
               class="grid-item"
               :key="index"
               @click="cateClick(item,index)"
          >
            <div class="title-strong" :class="{'active':selectIndex === index}">{{item.label}}</div>
            <div class="arrow">
              <img :src="require('@/assets/exchange/'+ (selectIndex === index?'arrow_down_active':'arrow_down') +'.png')">
            </div>
          </div>
        </div>
        <div class="ex-content-bg">
          <div class="zc-content ex-content-common" v-if="selectIndex===0">
            <div class="zc-content-left">
              <div class="zc-left-title">「以旧换新福利」</div>
              <div class="table-content">
                <div class="table-content-tr">
                  <div class="td-1">*线上报名</div>
                  <div class="td-2">一组客户可免费评估二手房一次</div>
                </div>
                <div class="table-content-tr">
                  <div class="td-1">*线上成交</div>
                  <div class="td-2">可额外享受新房总价1%优惠<span>(税前)</span></div>
                </div>
              </div>
              <div>
                <p>1、直接收房-直接抵押-直接打款</p>
                <p>2、0中介费、0契税、0评估费</p>
                <p>3、收购评估价透明</p>
              </div>
            </div>
            <div class="zc-content-right">
              <div class="zc-left-title">「已成功置换分布图」</div>
              <img src="@/assets/exchange/ditu.png">
            </div>
          </div>
          <div class="cy-content" v-if="selectIndex===1">
            <div class="slider1">
              <div class="cy-content-item">
                <div class="cy-content-item-top">
                  <img src="@/assets/exchange/house1_icon.png">
                </div>
                <div class="cy-content-item-bottom">
                  <div class="cy-content-item-left">
                    <div class="cy-table-content">
                      <div class="table-content-tr">
                        <div class="td-1">参考价格</div>
                        <div class="td-2 price-text">22000元/㎡-30000元/㎡</div>
                      </div>
                      <div class="table-content-tr">
                        <div class="td-1">产品信息</div>
                        <div class="td-2 bold-text">千年天赋地继·全球师著精工 <pre class="mini-text">建筑 面积约</pre>143-690㎡当代豪宅范本</div>
                      </div>
                      <div class="table-content-tr">
                        <div class="td-1">项目地址</div>
                        <div class="td-2 bold-text">蔷薇公园旁 天宁风华路与夏雷答交界处</div>
                      </div>
                      <div class="table-content-tr">
                        <div class="td-1">项目简介</div>
                        <div class="td-2">
                          山和风华一一常州第五座风华系,傲踞天宁主城,市中心丽华板块、采菱河,蔷薇公园,市政水系三河三圈环伺，优享生态自然;紧邻金腰带中吴大道,
                          <span class="bold-text">距离地铁4号线(规划中)、6号线(规划中)直线距高约1km;距离万象城直线距离约2.3km,项目配备六恒科技舒适系统,</span>
                          营造更舒适的居住体验,打造高阶风华生活。
                          <div class="mini-text min-text-wid">(地铁规划信息来源于:常州人民政府官网)</div>
                        </div>
                      </div>
                      <div class="table-content-tr">
                        <div class="td-1">开发企业</div>
                        <div class="td-2 bold-text">嘉宏地产</div>
                      </div>
                    </div>
                  </div>
                  <div class="cy-content-item-right">
                    <img src="@/assets/exchange/house1.jpg">
                  </div>
                </div>
              </div>
              <div class="cy-content-item">
                <div class="cy-content-item-top">
                  <img src="@/assets/exchange/house2_icon.png">
                </div>
                <div class="cy-content-item-bottom">
                  <div class="cy-content-item-left">
                    <div class="cy-table-content">
                      <div class="table-content-tr">
                        <div class="td-1">参考价格</div>
                        <div class="td-2 price-text">28000元/㎡-30000元/㎡</div>
                      </div>
                      <div class="table-content-tr">
                        <div class="td-1">产品信息</div>
                        <div class="td-2 bold-text"><pre class="mini-text">建筑 面积约</pre>360㎡六恒科技宽幕平墅·最后9席 封藏武进芯</div>
                      </div>
                      <div class="table-content-tr">
                        <div class="td-1">项目地址</div>
                        <div class="td-2 bold-text">
                          武进星火北路与古方路交汇处
                        </div>
                      </div>
                      <div class="table-content-tr">
                        <div class="td-1">项目简介</div>
                        <div class="td-2">
                          一江风华--嘉宏“风华系”第三子,以强大的品牌与产品基因,择址武进芯毗陵宫中轴之上,代言常州千万级奢宅新气度。
                          <span class="bold-text">项目周边13所学府环伺，商圈云集,与200+亩城市生态公园一路之隔;凭借一轴九景的园林造诣以及全屋高定精装搭载六恒科技系统，</span>
                          入围《2023全国十大交付力作品》榜单，成为龙城高阶人群的改善之选。
                        </div>
                      </div>
                      <div class="table-content-tr">
                        <div class="td-1">开发企业</div>
                        <div class="td-2 bold-text">嘉宏地产</div>
                      </div>
                    </div>
                  </div>
                  <div class="cy-content-item-right">
                    <img src="@/assets/exchange/house2.jpg">
                  </div>
                </div>
              </div>
            </div>
            <div class="ex_mode_slider_pagination">
              <span v-for="(item1,index1) in 2" :key="index1"
                    class="ex_mode_slider_pagination_bg"
                    @click="paginationClick(index1)">
                <span class="ex_mode_slider_pagination_item">
<!--                  transition: opacity .5s ease-in;-->
                  <span class="ex_mode_slider_pagination_line" :style="currentSlide === index1?'opacity: 1;':'opacity: 0;'">
                  </span>
                </span>
              </span>
            </div>
          </div>
          <div class="bm-content ex-content-common"  v-if="selectIndex===2">
            <div class="bm-title">置换原则</div>
            <p>1、必须以购买嘉宏地产旗下可置换项目为前提</p>
            <p>2、旧房的置换总价需低于新房总价的75%</p>
            <div class="bm-title">旧房置换条件</div>
            <p> 1、常州市区的住宅商品房,无抵押,有产权,可过户可使用</p>
            <p>2、未列入危房或年度政府拆迁、成套改造计划或因纠纷已进入诉讼、仲裁、行政处罚程序的房屋</p>
            <p>3、该房屋有对应的房屋所有权证、土地使用权证,如产权共有需经共有人同意，并且未进行任何抵押</p>
            <p> 4、该房屋必须有正常的使用功能,房屋保持完好</p>
            <div class="bm-bottom display-row">
              <img class="bm-icon" src="@/assets/exchange/code_icon.png">
              <div class="bm-bottom-right">
                <p>如果您对<span class="bm-bottom-bold text-blue">以旧换新 </span>感兴趣</p>
                <p>欢迎通过线上报名通道与我们联系</p>
                <p>或致电  <span class="bm-bottom-bold text-blue">131 8297 2027</span></p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="exchange-bottom">
        <h3 class="text-blue site-text__content_h3">以旧换新参与流程</h3>
        <div class="exchange-bottom-content">
          <div v-for="(item,index) in stepList" :key="index" class="exchange-bottom-item">
            <div class="step">STEP {{index+1}}</div>
            <div class="step-name">{{item.text}}</div>
            <div class="step-name">{{item.text1}}</div>
            <div v-if="index != stepList.length-1" class="arrow-img"></div>
          </div>
        </div>
      </div>
      <div class="exchange-video-content">
        <div class=" exchange-video-item">
          <div class="video-slider">
                <div class="video-bg">
                  <video
                          id="video0"
                          ref="videoPlayer"
                          class="exchange-video-class"
                          webkit-playsinline="true"
                          x-webkit-airplay="true"
                          playsinline="true"
                          x5-video-player-type="h5"
                          preload='auto'
                          poster="@/assets/exchange/poster1.png"
                          >
                    <source type="video/mp4">
                  </video>
                  <div v-if="video_button" class="ex-video-btn" @click="videoSliderClick('video0')"></div>
                </div>
          </div>
          <div class="text-name">成功以旧换新案例</div>
        </div>
        <div class="exchange-video-item">
          <div class="video-bg">
            <video
                    id="video2"
                    class="exchange-video-class"
                    webkit-playsinline="true"
                    x-webkit-airplay="true"
                    playsinline="true"
                    x5-video-player-type="h5"
                    preload='auto'
                    poster="@/assets/exchange/poster2.png"
                    loop>
              <source src="@/assets/exchange/video2.mp4" type="video/mp4">
            </video>
            <div v-if="videos['video2'].button" class="ex-video-btn" @click="videoClick('video2')"></div>
          </div>
          <div class="text-name">以旧换新操作指引</div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
let that = null
import topNav from '@/components/base/top-nav'
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import $ from 'jquery';
import 'slick-carousel';
import video0Url from '@/assets/exchange/video1_1.mp4';
import video1Url from '@/assets/exchange/video1_2.mp4';

export default {
  name: "exchange",
  components:{
    topNav
  },
  data() {
    return {
      lastScrollTop: 0, // 记录上次滚动位置
      cateList:[
        {
          label:'政策活动',
          value:'1'
        },
        {
          label:'参与项目',
          value:'2'
        },
        {
          label:'点击报名',
          value:'3'
        }
      ],
      stepList:[
        {
          text: '确定',
          text1: '置换房源'
        },
        {
          text: '旧房',
          text1: '免费评估'
        },
        {
          text: '认购',
          text1: '新房'
        },
        {
          text: '抵押',
          text1: '打款'
        },
        {
          text: '新房',
          text1: '签约'
        }
      ],
      videoList:[
        {
          id:'video0',
          src:'video1_1.mp4'
        },
        {
          id:'video1',
          src:'video1_2.mp4'
        }
      ],
      video_button:true,
      videos:{
        'video2':{
          button:true
        }
      },
      selectIndex: 0,
      currentSlide:0,
      isUpdate:false,
      currentVideo: null,
      currentPlayIndex:0
    }
  },
  mounted() {
    that = this
  },
  beforeDestroy() {

  },
  methods: {
    handleResize(){
      $('.slider1').slick('setPosition');
      $('.slider1').slick('resize');
    },
    cateClick(item,index){
      this.selectIndex = index;
      if(index == 1){
        this.currentSlide = 0
        this.initSlider()
        $('.slider1').slick('setPosition');
        $('.slider1').slick('resize');
      }else{
        $('.slider1').slick('unslick');
      }
    },
    /**
     * 初始化轮播
     */
    initSlider() {
      this.$nextTick(() => {
        $('.slider1').slick({
          // vertical: true,
          dots:false,
          arrows: false,
          initialSlide: 0,
          slidesToShow: 1,
          slidesToScroll: 1,
          draggable:true,
          fade: true,
          // speed: 1000
        });
        $('.slider1').slick('setPosition');
        $('.slider1').on('afterChange', function pauseSlideShow(event, slick, currentSlide){
          that.currentSlide = currentSlide
        });
        $('.cy-content .slider1 .slick-slide').removeAttr('aria-hidden')
      });
    },
    paginationClick(index){
      $('.slider1').slick('slickGoTo', index);
      // 重置动画
      that.currentSlide = index
    },
    videoSliderClick(videoId){
      that.playVideo(videoId)
      that.video_button = false
    },
    videoClick(videoId){
      let video = document.getElementById(videoId);
      video.play();
      video.controls = true;
      that.videos[videoId].button = false
    },
    playVideo(videoId){
      this.currentPlayIndex = 1;
      let video = document.getElementById(videoId);
      video.src = video0Url
      video.play();
      video.addEventListener('timeupdate', function() {
        // console.log("video.duration",video.currentTime+0.2,video.duration)
        if (video.currentTime+0.2 >= video.duration) {
          video.pause();
          if(that.currentPlayIndex%2 == 1){
            video.src = video1Url;
          }
          if(that.currentPlayIndex%2 == 0){
            video.src = video0Url;
          }
          that.currentPlayIndex ++;
          video.play()
        }
      });
      video.controls = true;
    },
  }
}
</script>

<style>
  @import "../../styles/exchange.css";
</style>
